import React from 'react';
import DiscourseNavigation from './DiscourseNavigation';
import InfiniteScroll from 'react-infinite-scroll-component';
import ListOfDiscourse from './ListOfDiscourse';

import {
  useYourDiscourseState,
  useYourDiscourseActions
} from './YourDiscourseContext';
import YourDiscourseLoader from './YourDiscourseLoader';
import { useYourDiscourseCapabilities } from './useYourDiscourseCapabilities';

import { getDocumentsForUser } from './restApi';

import styles from './DiscourseIndex.module.scss';

const YOUR_VIEW_STATE_OPTIONS = [
  { value: 'draft', label: 'Drafts' },
  { value: 'pending_approval', label: 'Pending Approval' },
  { value: 'pending_revision', label: 'Pending Revision' },
  { value: 'published', label: 'Published' },
  { value: 'denied', label: 'Denied' },
];

const YourDiscourseContent = ({ authenticatedUser }) => {
  useYourDiscourseCapabilities(authenticatedUser);
  const state = useYourDiscourseState();
  const { onResponse, onError, setViewState } = useYourDiscourseActions();

  const loadMoreDocuments = () => {
    const nextPageNumber = (state.pageNumberByViewState?.[state.viewState] || 0) + 1;
    getDocumentsForUser({
      viewState: state.viewState || 'published',
      pageNumber: nextPageNumber,
      onResponse,
      onError,
    });
  };

  return (
    <>
      <section className={styles.pageSection}>
        <DiscourseNavigation
          viewState={state.viewState}
          onViewStateChange={setViewState}
          viewStateOptions={YOUR_VIEW_STATE_OPTIONS}
        />
      </section>
      <InfiniteScroll
        dataLength={(state.documentsByViewState?.[state.viewState] || []).length}
        next={loadMoreDocuments}
        hasMore={state.moreDocumentsAvailableByViewState?.[state.viewState] ?? true}
        loader={
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        }
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>You've seen all available articles</b>
          </p>
        }
        scrollableTarget="html"
      >
        <ListOfDiscourse discourse={state.documentsByViewState?.[state.viewState] || []} />
      </InfiniteScroll>
    </>
  );
};

const YourDiscourse = ({ authenticatedUser }) => {
  return (
    <>
      <YourDiscourseLoader />
      <YourDiscourseContent authenticatedUser={authenticatedUser} />
    </>
  );
};

export default YourDiscourse;
